import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { ContribuyentesService, OptionsService } from '../../services/service.index';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-altacyp',
  templateUrl: './altacyp.component.html',
  styleUrls: ['./altacyp.component.css']
})
export class AltaCyPComponent implements OnInit {
  actualizaproveedorEmitter = new EventEmitter<Object>();
  actualizacadenaEmitter = new EventEmitter<Object>();
  creaaproveedorEmitter = new EventEmitter<Object>();
  creacadenaEmitter = new EventEmitter<Object>();
  constructor(
               public _contribuyentesService: ContribuyentesService,
               public _optionsservice: OptionsService,
               public router: Router,
               public http: HttpClient ) { }

  parametros: any[] = [];
  cols: any[];
  selectedFac: any[];
  contribuyentes: any[];
  fileName = 'ReporteContribuyentes.xlsx';
  _selectedColumns: any[];
  showap = false;
  showac = false;
  showcp = false;
  showcc = false;
  ngOnInit() {
    swal2.showLoading();
   // this.getAcceso('/altacyp');
    this._contribuyentesService.getContribuyentesMain().subscribe( resp => {this.contribuyentes = resp; swal2.close(); } );

    this.cols = [

      { field: 'rfc_contribuyente', header: 'RFC' },
      { field: 'nombre', header: 'Nombre' },
      { field: 'correo', header: 'Correo' },
      { field: 'es_cadena', header: 'Empresa' },
      { field: 'es_proveedor', header: 'Proveedor' }

  ];

    this._selectedColumns = this.cols;

  }
  

  rcproveedor(value) {
    this._contribuyentesService.getContribuyentesMain().subscribe( resp => {this.contribuyentes = resp; swal2.close(); } );
    this.acproveedor(value.contid, value.nomcont);
  }

  ccproveedor(value) {
    this._contribuyentesService.getContribuyentesMain().subscribe( resp => {this.contribuyentes = resp; swal2.close(); } );
    this.accadena(value.contid, value.nomcont);
  }

  creaproveedor(contid, nomcont) {
    this.showap = false;
    this.showac = false;
    this.showcp = true;
    this.showcc = false;
    setTimeout(() => {
      this.creaaproveedorEmitter.emit({contid: contid, nomcont: nomcont});
    }, 100);   
  }

  creacadena(contid, nomcont) {
    this.showap = false;
    this.showac = false;
    this.showcp = false;
    this.showcc = true;
    setTimeout(() => {
      this.creacadenaEmitter.emit({contid: contid, nomcont: nomcont});
    }, 100); 
  }

  acproveedor(contid, nomcont) {
    this.showap = true;
    this.showac = false;
    this.showcp = false;
    this.showcc = false;
    setTimeout(() => {
      this.actualizaproveedorEmitter.emit({contid: contid, nomcont: nomcont});
    }, 100);   
  }

  accadena(contid, nomcont) {
    this.showap = false;
    this.showac = true;
    this.showcp = false;
    this.showcc = false;
    setTimeout(() => {
      this.actualizacadenaEmitter.emit({contid: contid, nomcont: nomcont});
    }, 100);   
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
}

set selectedColumns(val: any[]) {
  // restore original order
  this._selectedColumns = this.cols.filter(col => val.includes(col));
}

exportexcel() {
  /* table id is passed over here */
  const element = document.getElementById('tablaFacturas');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, this.fileName);
}

myFunction() {
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("myInput");
  filter = input.value.toUpperCase();
  table = document.getElementById("myTable");
  tr = table.getElementsByTagName("tr");
  for (i = 1; i < tr.length; i++) {
  td = tr[i];
  if (td) {
    txtValue = td.textContent || td.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      tr[i].style.display = "";
    } else {
      tr[i].style.display = "none";
    }
  }
}
}
}
